import gsap from "gsap";

export type GSAPTweenLike = gsap.core.Tween & {
  id: string;
  playPause: (time?: number) => void;
  reset: () => gsap.core.Tween;
};

const augment = (t: gsap.core.Tween, id?: string): GSAPTweenLike => {
  const tween = t as GSAPTweenLike;
  tween.id = id ?? crypto.randomUUID?.() ?? Math.random().toString(36).slice(2);
  
  tween.playPause = (time?: number) => {
    tween.play();
    if (time === undefined) tween.pause();
    else tween.pause(time);
  };
  
  tween.reset = () => {
    tween.restart();
    tween.pause();
    return tween;
  };

  return tween;
};

export const gsapFactory = {
  to(target: gsap.TweenTarget, vars: gsap.TweenVars, id?: string) {
    return augment(gsap.to(target, { ...vars, paused: true }), id);
  },
  from(target: gsap.TweenTarget, vars: gsap.TweenVars, id?: string) {
    return augment(gsap.from(target, { ...vars, paused: true }), id);
  },
  fromTo(
    target: gsap.TweenTarget,
    fromVars: gsap.TweenVars,
    toVars: gsap.TweenVars,
    id?: string
  ) {
    return augment(
      gsap.fromTo(target, { ...fromVars }, { ...toVars, paused: true }),
      id
    );
  },
};
